import { Link } from "react-router-dom";  
import { useTranslation } from "react-i18next";
  
export default function HomePage() {
  const { t } = useTranslation();
  return (
    <div className="homepage">

      {/* HERO SECTION */}
      <section className="hero-card">
        <div className="hero-title">
          🎓 {t('app.title')}
        </div>

        <h1 className="hero-subtitle">
          {t('home.subtitle')} <br /> {t('home.subtitleUniversity')} 
        </h1>

        <p className="hero-desc">
          {t('home.description')}
        </p>

        <div className="hero-features">

          <div className="hero-feature">
            🤖 {t('home.featureAI')}
          </div>

          <div className="hero-feature">
            📊 {t('home.featureAnalytics')}
          </div>

          <div className="hero-feature">
            ⭐ {t('home.featureSatisfaction')}
          </div>

        </div>
      </section>


      {/* QUICK ACTIONS */}
      <section className="home-actions">

        <Link to="/emails" className="action-card">
          <div className="action-icon">📥</div>
          <h3>{t('home.actionInbox')}</h3>
          <p>
            {t('home.actionInboxDesc')}
          </p>
          <span className="action-btn">{t('home.actionInboxBtn')}</span>
        </Link>


        <Link to="/stats" className="action-card">
          <div className="action-icon">📊</div>
          <h3>{t('home.actionAnalytics')}</h3>
          <p>
            {t('home.actionAnalyticsDesc')}
          </p>
          <span className="action-btn">{t('home.actionAnalyticsBtn')}</span>
        </Link>


        <Link to="/categories" className="action-card">
          <div className="action-icon">📂</div>
          <h3>{t('home.actionCategories')}</h3>
          <p>
            {t('home.actionCategoriesDesc')}
          </p>
          <span className="action-btn">{t('home.actionCategoriesBtn')}</span>
        </Link>

      </section>


      {/* SYSTEM FEATURES */}
      <section className="home-features">

        <div className="feature-card">
          <h4>{t('home.featureAutomatedTitle')}</h4>
          <p>
            {t('home.featureAutomatedDesc')}
          </p>
        </div>

        <div className="feature-card">
          <h4>{t('home.featureCollabTitle')}</h4>
          <p>
            {t('home.featureCollabDesc')}
          </p>
        </div>

        <div className="feature-card">
          <h4>{t('home.featureInsightsTitle')}</h4>
          <p>
            {t('home.featureInsightsDesc')}
          </p>
        </div>

      </section>

    </div>
  );
}
